import { LoadingOutlined } from "@ant-design/icons";
import { Button, Form, Input, Modal, Spin } from "antd";
import React, { useEffect, useState } from "react";

function DesignationsFilterModal(props) {
  const [submit, setSubmit] = useState(false);
  const [form] = Form.useForm();

  useEffect(() => {
    if (props.visible) {
      props.filterBy?.name &&
        form.setFields([{ name: "name", value: props.filterBy?.name }]);
      props.filterBy?.abbreviation &&
        form.setFields([
          { name: "abbreviation", value: props.filterBy?.abbreviation },
        ]);
    }
  }, [props.visible]);

  function handleCancel() {
    setSubmit(false);
    props.handleCancel();
    form.resetFields();
  }

  function onFinish(values) {
    setSubmit(true);
    props.handleOk(values);
    handleCancel();
  }

  return (
    <Modal
      title="Filter Designations"
      visible={props.visible}
      onCancel={() => handleCancel()}
      footer={null}
      destroyOnClose={true}
    >
      <Form
        name="designationFilter"
        onFinish={onFinish}
        autoComplete="off"
        layout="vertical"
        form={form}
      >
        <Form.Item label="Name" name="name">
          <Input placeholder="Name" />
        </Form.Item>

        <Form.Item label="Abbreviation" name="abbreviation">
          <Input placeholder="Abbreviation" />
        </Form.Item>

        <Form.Item style={{ marginBottom: 0 }}>
          <div className=" flex justify-end">
            <Button className="mr-3 w-28" onClick={props.handleCancel}>
              Cancel
            </Button>
            <Button
              className="w-28"
              type="primary"
              htmlType={submit && "submit"}
            >
              {submit ? (
                <Spin
                  size="small"
                  indicator={<LoadingOutlined style={{ color: "#fff" }} spin />}
                />
              ) : (
                "Filter"
              )}
            </Button>
          </div>
        </Form.Item>
      </Form>
    </Modal>
  );
}

export default DesignationsFilterModal;
